import { useEffect, useState } from 'react'

/**
 * Suscripción ligera a una media query, con render inicial seguro.
 */
export function useMediaQuery(query: string, defaultValue = false) {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return defaultValue
    return window.matchMedia(query).matches
  })

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return
    const list = window.matchMedia(query)
    const update = () => setMatches(list.matches)
    update()
    list.addEventListener('change', update)
    return () => list.removeEventListener('change', update)
  }, [query])

  return matches
}

/** true en pantallas de teléfono. */
export function useIsMobile() {
  return useMediaQuery('(max-width: 767px)')
}
